import { useEffect, useState } from "react";

// The business email is assembled in the browser after load so it never
// appears as plain text in the page source (protects it from scrapers).
const USER = ["adesigners", "home"];
const DOMAIN = ["gmail", "com"];

export function useBusinessEmail() {
  const [email, setEmail] = useState<string | null>(null);
  useEffect(() => {
    setEmail(USER.join("") + String.fromCharCode(64) + DOMAIN.join("."));
  }, []);
  return {
    label: email ?? "Email us",
    href: email ? `mailto:${email}` : "/contact",
  };
}
